<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">{{ modalLabel }} </span>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="palletTypeAddEditForm">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required" aria-required="true">
            <div class="services-form">
              <input formControlName="palletName" type="text" maxlength="100" placeholder="Name" />
              <label>Name</label>
              <div *ngIf="submitted && palletTypeAddEditForm.controls['palletName'].errors">
                <div
                  *ngIf="palletTypeAddEditForm.controls['palletName'].errors?.['required']"
                  class="input-error"
                >
                  Name is required.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group textarea" aria-required="true">
            <div class="services-form">
              <textarea
                formControlName="description"
                cols="20"
                id="Description"
                name="Description"
                rows="2"
                placeholder="Description"
              ></textarea>
              <label>Description</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group required" aria-required="true">
            <label
              *ngIf="palletTypeAddEditForm.get('organizationName')?.value"
              class="placeholder-sub-header pb-2"
              >Holder_text</label
            >
            <div class="services-form">
              <input
                formControlName="mass"
                type="number"
                maxlength="50"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                placeholder="Mass"
              />
              <label>Mass</label>
              <div *ngIf="submitted && palletTypeAddEditForm.controls['mass'].errors">
                <div
                  *ngIf="palletTypeAddEditForm.controls['mass'].errors?.['required']"
                  class="input-error"
                >
                  This field is required
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group required organizationdrpDown">
            <label
              *ngIf="palletTypeAddEditForm.get('organizationName')?.value"
              class="sub-header-drpdown pb-2"
              >Organization</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #organization
              [items]="organizationlist"
              [searchable]="false"
              bindLabel="name"
              formControlName="organizationName"
              [searchFn]="commonInputSearch"
              placeholder="All organization"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="organization.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer text-margin">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
